var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutubeBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 8,
    fill: "#828282"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.7609 16.0528C32.7609 16.0528 32.5266 14.2116 31.8047 13.4031C30.8906 12.339 29.8688 12.3338 29.4 12.2712C26.0438 12 21.0047 12 21.0047 12H20.9953C20.9953 12 15.9563 12 12.6 12.2712C12.1313 12.3338 11.1094 12.339 10.1953 13.4031C9.47344 14.2116 9.24375 16.0528 9.24375 16.0528C9.24375 16.0528 9 18.2174 9 20.3768V22.4006C9 24.56 9.23906 26.7246 9.23906 26.7246C9.23906 26.7246 9.47344 28.5658 10.1906 29.3743C11.1047 30.4384 12.3047 30.4018 12.8391 30.5166C14.7609 30.72 21 30.7826 21 30.7826C21 30.7826 26.0438 30.7722 29.4 30.5062C29.8688 30.4436 30.8906 30.4384 31.8047 29.3743C32.5266 28.5658 32.7609 26.7246 32.7609 26.7246C32.7609 26.7246 33 24.5652 33 22.4006V20.3768C33 18.2174 32.7609 16.0528 32.7609 16.0528ZM18.5203 24.8573V17.3516L25.0031 21.1175L18.5203 24.8573Z",
    fill: "#262627"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeBlack);
export default __webpack_public_path__ + "static/media/youtubeBlack.2a2d3f2060162138775a36608814f867.svg";
export { ForwardRef as ReactComponent };